<template>
    <div>
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header mb-4">
            <div class="title-breadcrumb">
                <div class="header-buttons">
                    <button
                        v-if="
                            (!integracao && !isUpdate && permissao.create) ||
                            (!integracao && isUpdate && permissao.update)
                        "
                        @click="save"
                        :disabled="isSaving"
                        class="save-btn"
                        type="button"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-2">
                    <v-input
                        :id="generateId(7)"
                        ref="idagroniveltecnologicoerpInput"
                        v-model="nivelTecnologico.idagroniveltecnologicoerp"
                        placeholder="placeholder-preencha"
                        :maxlength="30"
                        title="codigo"
                        uppercase
                    />
                </div>
                <div class="column is-8">
                    <v-input
                        :id="generateId(1)"
                        ref="descricaoInput"
                        v-model="nivelTecnologico.descricao"
                        placeholder="placeholder-preencha"
                        :maxlength="255"
                        :title="'descricao'"
                        :msg="'msg-campo-obrigatorio'"
                        :invalid="!nivelTecnologico.descricao"
                        :disabled="
                            integracao ||
                            (isUpdate && !permissao.update) ||
                            (!isUpdate && !permissao.create)
                        "
                        uppercase
                        tooltipLabel="nivel-tecnologico-tooltip-descricao"
                        tooltipSize="is-small"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                        :required="true"
                        :validchars="inputsValidchars"
                    />
                </div>
                <div class="column is-2">
                    <label for="situacao" v-text="$t('situacao')" />
                    <vss-select
                        :id="generateId(2)"
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacoes"
                        v-model="situacao"
                        class="no-clear"
                        :mlLabels="true"
                        :disabled="
                            integracao ||
                            nivelTecnologico.id == null ||
                            (isUpdate && !permissao.update)
                        "
                    />
                </div>
            </div>
            <div class="columns is-flex-wrap">
                <div class="column is-6">
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <vss-select
                                :id="generateId(8)"
                                ref="safraSelect"
                                :disabled="
                                    integracao ||
                                    (isUpdate && !permissao.update) ||
                                    (!isUpdate && !permissao.create)
                                "
                                title="safra"
                                placeholder="selecione"
                                :options="safraSelect"
                                v-model="safraSelected"
                                tooltipLabel="msg-tooltip-safra"
                                tooltipSize="is-small"
                                @onBlurFunction="sendIsChanged()"
                                @search="carregarSafra"
                                searchable
                                clearable
                            />
                        </div>
                        <div class="control padding-label padding-label-custom">
                            <b-button
                                v-if="
                                    !integracao &&
                                    !integracaoAgroSafra &&
                                    canCreateNewSafra &&
                                    ((isUpdate && permissao.update) ||
                                        (!isUpdate && permissao.create))
                                "
                                @click="TelaCadastroSafra"
                                icon-right="plus"
                                v-tippy
                                :title="$t('adicionar')"
                            />
                        </div>
                    </div>
                </div>
                <div class="column is-6">
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <vss-select
                                :id="generateId(4)"
                                ref="culturaSelect"
                                :disabled="
                                    integracao ||
                                    (isUpdate && !permissao.update) ||
                                    (!isUpdate && !permissao.create)
                                "
                                title="cultura"
                                placeholder="selecione"
                                :options="culturaSelect"
                                v-model="culturaSelected"
                                tooltipLabel="msg-tooltip-cultura"
                                tooltipSize="is-small"
                                :required="true"
                                :invalid="culturaSelected == null"
                                @onBlurFunction="sendIsChanged()"
                                @search="carregarCultura"
                                searchable
                            />
                        </div>
                        <div class="control padding-label padding-label-custom">
                            <b-button
                                v-if="
                                    !integracao &&
                                    !integracaoTipoCultura &&
                                    canCreateNewCultura &&
                                    ((isUpdate && permissao.update) ||
                                        (!isUpdate && permissao.create))
                                "
                                @click="TelaCadastroCultura"
                                icon-right="plus"
                                v-tippy
                                :title="$t('adicionar')"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-flex-wrap">
                <div class="column is-6">
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <vss-select
                                :id="generateId(5)"
                                ref="empresaSelect"
                                :disabled="
                                    integracao ||
                                    (isUpdate && !permissao.update) ||
                                    (!isUpdate && !permissao.create)
                                "
                                :options="empresaSelect"
                                v-model="empresaSelected"
                                title="empresa"
                                placeholder="selecione"
                                tooltipLabel="msg-tooltip-empresa"
                                tooltipSize="is-small"
                                :required="true"
                                :invalid="empresaSelected == null"
                                :loading="empresasLoading"
                                @search="carregarEmpresas"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="control padding-label padding-label-custom">
                            <b-button
                                v-if="
                                    !integracao &&
                                    !integracaoEmpresa &&
                                    canCreateNewEmpresa &&
                                    ((isUpdate && permissao.update) ||
                                        (!isUpdate && permissao.create))
                                "
                                @click="TelaCadastroEmpresa"
                                icon-right="plus"
                                v-tippy
                                :title="$t('adicionar')"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmpresaService from '@/services/vendas/empresa/EmpresaService';
import NivelTecnologicoService from '@/services/agro/nivel-tecnologico/NivelTecnologicoService';
import NivelTecnologicoValidation from '@/services/validations/NivelTecnologicoValidation';
import Message from '@/models/Message';

/* @71147 - aba nível tecnológico */
export default {
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes(
                'AGRO_NIVELTECNOLOGICO'
            ),
            integracaoAgroSafra: this.$store.state.user.tabelasERPWebServer.includes('AGRO_SAFRA'),
            integracaoEmpresa: this.$store.state.user.tabelasERPWebServer.includes('EMPRESA'),
            integracaoTipoCultura: this.$store.state.user.tabelasERPWebServer.includes(
                'TIPOCULTURA'
            ),
            service: new NivelTecnologicoService(this.$http, this.$router),
            validation: new NivelTecnologicoValidation(this.msgs),
            empresaService: new EmpresaService(this.$http, this.$router),
            isLoading: false,
            isSaving: false,
            nivelTecnologico: {
                idagroniveltecnologico: null,
                idagroniveltecnologicoerp: null,
                descricao: '',
                idcultura: null,
                idsafra: null,
                idempresa: null,
                situacao: null,
            },
            editable: false,
            title: '',
            msgs: [],
            permissao: {},
            permissaoSafra: {},
            permissaoCultura: {},
            permissaoEmpresa: {},
            canCreateNewSafra: true,
            canCreateNewCultura: true,
            canCreateNewEmpresa: true,
            isUpdate: false,
            allowedCreate: false,
            allowedUpdate: false,
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },

            isChanged: false,
            isLoadingEdit: false,

            //Listas para receber valores da combobox
            culturaSelect: [],
            safraSelect: [],
            empresaSelect: [],

            //variáveis para armazenar os valores selecionados nas combobox
            culturaSelected: null,
            safraSelected: null,
            empresaSelected: null,
            empresasLoading: false,
            inputsValidchars:
                'ÁÉÍÓÚÀÈÌÒÙÃÕÂÊÔÛ' +
                'áéíóúàèìòùãõâêôû' +
                'abcdefghijklmnopqrstuvwxyz' +
                'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
                '0123456789' +
                '.,;:-+*&%$#@!?=()[]{}´`¬~^°º/\\|_ ',

            /*
            permissões de acesso aos modais de cadastro
            cultivarIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("CULTIVAR"),
            safraIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("AGRO_SAFRA"),
            empresaIntegração:
                this.$store.state.user.tabelasERPWebServer.includes("EMPRESA"),
            */
        };
    },
    created() {
        this.isUpdate = this.$route.params.id != null && this.$route.params.id != 'new';

        this.permissao = this.hasPermissionAccess(
            'agro',
            'agro-cadastros',
            'agro-niveltecnologico'
        );

        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'agro-niveltecnologico' },
            });
        }

        if (this.nivelTecnologico != null && this.nivelTecnologico != {}) {
            this.editable = true;
        }

        this.allowedCreate = !this.isUpdate && this.permissao.create && !this.integracao;

        this.allowedUpdate = this.isUpdate && this.permissao.update && !this.integracao;

        this.permissaoSafra = this.hasPermissionAccess('agro', 'agro-cadastros', 'agro-safra');
        this.canCreateNewSafra = this.permissaoSafra.create;

        this.permissaoCultura = this.hasPermissionAccess('agro', 'agro-cadastros', 'agro-cultura');
        this.canCreateNewCultura = this.permissaoCultura.create;

        this.permissaoEmpresa = this.hasPermissionAccess('vendas', 'empresa', 'ven-empresa');
        this.canCreateNewEmpresa = this.permissaoEmpresa.create;

        if (this.isUpdate) {
            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados(this.$route.params.id);
            }
        } else {
            this.carregarSafra();
            this.carregarCultura();
            this.carregarEmpresas('');
        }
    },

    watch: {
        nivelTecnologico: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.isChanged = true;
                }
            },
        },
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },

        sendIsChanged() {
            if (!this.isLoadingEdit) this.isChanged = true;
        },

        carregarDados(id) {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .find(id)
                .then((body) => {
                    if (body.content) {
                        this.nivelTecnologico = body.content;

                        if (this.nivelTecnologico.situacao == 0) {
                            this.situacao = { label: 'inativo', id: 0 };
                        }

                        this.title = this.nivelTecnologico.descricao;
                    } else {
                        this.$router.push({ name: 'agro-niveltecnologico-new' });
                    }
                })
                .finally(() => {
                    this.isChanged = false;
                    this.isLoadingEdit = false;
                    this.isLoading = false;

                    this.carregarSafra();
                    this.carregarCultura();
                    this.carregarEmpresa();
                });
        },
        carregarSafra(q) {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .loadSafra(20, q)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idsafra,
                            label: m.descricao,
                        };
                    });
                })
                .then((r) => {
                    this.safraSelect = r;
                })
                .finally(() => {
                    this.isChanged = false;
                    this.isLoading = false;
                    this.isLoadingEdit = false;

                    if (
                        this.safraSelected == null &&
                        this.isUpdate &&
                        this.nivelTecnologico.idsafra > 0
                    ) {
                        this.safraSelected = {
                            id: this.nivelTecnologico.idsafra,
                            label: this.nivelTecnologico.safra.descricao,
                        };
                    }
                });
        },
        carregarCultura(q) {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .loadCultura(20, q)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idtipocultura,
                            label: m.descricao,
                        };
                    });
                })
                .then((r) => {
                    this.culturaSelect = r;
                    if (this.culturaSelect.length == 1) {
                        this.culturaSelected = this.culturaSelect[0];
                    }
                })
                .finally(() => {
                    this.isChanged = false;
                    this.isLoading = false;
                    this.isLoadingEdit = false;

                    if (
                        this.culturaSelected == null &&
                        this.isUpdate &&
                        this.nivelTecnologico.idcultura > 0
                    ) {
                        this.culturaSelected = {
                            id: this.nivelTecnologico.idcultura,
                            label: this.nivelTecnologico.cultura.descricao,
                        };
                    }
                });
        },
        /*
            @84626
            retornar empresas que estão associadas a um usuário informado. Caso o usuário for admin,
            retorna todas as empresas
        */
        carregarEmpresas(q) {
            this.empresasLoading = true;
            this.empresaService
                .findList(q)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `[NIVEL TECNOLOGICO] Erro status ${r.status} ao carregar empresas.`
                        );
                        console.error(`[FENOLOGIA] Mensagem: ${r.message}`);
                    } else {
                        this.empresaSelect = r.content.map((e) => {
                            return {
                                id: e.idempresa,
                                label: e.nome,
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error('[NIVEL TECNOLOGICO] Erro ao carregar empresas.', e);
                })
                .finally((_) => {
                    //preenche automaticamente se só tiver um valor
                    if (this.empresaSelect.length == 1 && !this.cantEdit) {
                        this.empresaSelected = this.empresaSelect[0];
                    }
                    if (
                        this.empresaSelected == null &&
                        this.isUpdate &&
                        this.nivelTecnologico.idempresa > 0
                    ) {
                        let tempEmpresa = this.empresaSelect.filter(
                            (e) => e.id == this.nivelTecnologico.idempresa
                        );
                        if (tempEmpresa.length > 0) {
                            this.empresaSelected = tempEmpresa[0];
                        }
                    }
                    this.empresasLoading = false;
                });
        },
        save() {
            this.isLoading = true;

            if (this.safraSelected) {
                this.nivelTecnologico.idsafra = this.safraSelected.id;
            }

            if (this.culturaSelected) {
                this.nivelTecnologico.idcultura = this.culturaSelected.id;
            }

            if (this.empresaSelected) {
                this.nivelTecnologico.idempresa = this.empresaSelected.id;
            }

            if (this.situacao) {
                this.nivelTecnologico.situacao = this.situacao.id;
            }

            if (this.validation.validate(this.nivelTecnologico, this.$refs)) {
                let nivelTecnologicoTemp = Object.assign({}, this.nivelTecnologico);
                nivelTecnologicoTemp = this.mapTosave(nivelTecnologicoTemp);
                nivelTecnologicoTemp.idagroniveltecnologico = this.$route.params.id;

                this.isSaving = true;
                this.service
                    .save(nivelTecnologicoTemp)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-niveltecnologico-salva';
                            if (this.nivelTecnologico.idagroniveltecnologico) {
                                msg = 'msg-niveltecnologico-edita';
                            }
                            this.nivelTecnologico = body.content;
                            this.isChanged = false;
                            this.isLoadingEdit = true;
                            this.msgs.push(new Message('success', msg, true));
                            this.redirectToList(body.content.id);
                        } else {
                            if (this.$t(body.message)) {
                                this.msgs.push(new Message('alert', body.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                        this.isSaving = false;
                    })
                    .catch(() => {
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.isLoading = false;
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
            }
        },
        TelaCadastroCultura() {
            if (!this.nivelTecnologico.idagroniveltecnologico) {
                this.$router.push({
                    name: 'agro-cultura-new',
                    query: {
                        tela: 'agro-niveltecnologico-new',
                    },
                });
            } else {
                this.$router.push({
                    name: 'agro-cultura-new',
                    query: {
                        tela: 'agro-niveltecnologico-edit',
                        id: this.nivelTecnologico.idagroniveltecnologico,
                    },
                });
            }
        },
        TelaCadastroSafra() {
            if (!this.nivelTecnologico.idagroniveltecnologico) {
                this.$router.push({
                    name: 'agro-safra-new',
                    query: {
                        tela: 'agro-niveltecnologico-new',
                    },
                });
            } else {
                this.$router.push({
                    name: 'agro-safra-new',
                    query: {
                        tela: 'agro-niveltecnologico-edit',
                        id: this.nivelTecnologico.idagroniveltecnologico,
                    },
                });
            }
        },
        TelaCadastroEmpresa() {
            if (!this.nivelTecnologico.idagroniveltecnologico) {
                this.$router.push({
                    name: 'ven-empresa-dados-cadastrais-new',
                    query: {
                        tela: 'agro-niveltecnologico-new',
                    },
                });
            } else {
                this.$router.push({
                    name: 'ven-empresa-dados-cadastrais-new',
                    query: {
                        tela: 'agro-niveltecnologico-edit',
                        id: this.nivelTecnologico.idagroniveltecnologico,
                    },
                });
            }
        },
        promptChangeTab() {
            if (this.isChanged) {
                this.$root.confirm({
                    message: this.$t('msg-tem-certeza-alteracoes'),
                    onConfirm: (_) => {
                        this.redirect();
                    },
                });
            } else {
                this.redirect();
            }
        },
        redirect() {
            this.$router.push({ name: 'agro-niveltecnologico' });
        },

        redirectToList(id) {
            setTimeout(() => {
                this.$router.push({
                    name: 'agro-niveltecnologico-edit',
                    params: { id: id },
                });
            }, 1000);
        },
    },
};
</script>

<style lang="scss" scoped>
.page-container {
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }

    .control.is-expanded {
        max-width: calc(100% - 42px);
    }
}
</style>
